<template>
  <div class="goodslist">
    <!-- 操作栏：批量删除 + 筛选区域 -->
    <el-row type="flex" justify="space-between" align="middle" class="tool-tips">
      <el-col>
        <el-button type="danger" @click="handleDeleteBatch">批量删除</el-button>
      </el-col>
      <!-- 右侧筛选区域：多个col横向排列 -->
  <el-col :span="18" style="text-align:right; display: flex;">
    <el-input
      v-model="order_sn"
      placeholder="订单号筛选"
      style="width: 220px;display:inline-block;margin-right:8px"
      @keyup.enter.native="handleSearch"
    ></el-input>

    <el-input
      v-model="filter_email"
      placeholder="用户邮箱筛选"
      style="width: 220px;display:inline-block;margin-right:8px"
      @keyup.enter.native="handleSearch"
    ></el-input>

    <el-input
      v-model="filter_user_id"
      placeholder="用户id筛选"
      style="width: 220px;display:inline-block;margin-right:8px"
      @keyup.enter.native="handleSearch"
    ></el-input>

    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
  </el-col>
    </el-row>

    <!-- 订单表格 -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" width="55"></el-table-column>

      <el-table-column label="订单ID" align="center" prop="order_id" width="90"></el-table-column>
      <el-table-column label="订单编号" align="center" prop="order_sn"></el-table-column>
      <el-table-column prop="email" align="center" label="会员邮箱"></el-table-column>
      <el-table-column label="订单状态" align="center" prop="status_text" width="130">
        <template slot-scope="scope">
          <el-tag :type="getTagType(scope.row.order_status)">
            {{ scope.row.status_text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="订单金额" align="center" prop="actual_pay_price" width="110">
        <template slot-scope="scope">
          ￥{{ scope.row.actual_pay_price / 100 }}
        </template>
      </el-table-column>
      <el-table-column label="下单时间" align="center" prop="create_time" width="190"></el-table-column>
      <el-table-column label="操作" align="center" width="240">
        <template slot-scope="scope">
          <el-button type="text" @click="openDetail(scope.row)">查看详情</el-button>
          <el-button type="text" size="small" @click="openStatusDialog(scope.row)">修改状态</el-button>
          <el-button type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete" circle size="mini"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalcount"
      class="pagination"
    ></el-pagination>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="detailVisible" width="72%" @close="resetDetail">
      <OrderDetail :orderInfo="selected_order" />
    </el-dialog>

    <!-- 修改订单状态弹窗 -->
    <el-dialog title="修改订单状态" :visible.sync="statusDialogVisible" width="440px">
      <el-form label-width="100px">
        <el-form-item label="订单编号">
          <span>{{ editOrder.order_sn }}</span>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="editOrder.order_status" placeholder="请选择状态" style="width:100%">
            <el-option label="已创建(待支付)" :value="0"></el-option>
            <el-option label="已回复" :value="1"></el-option>
            <el-option label="已确认" :value="2"></el-option>
            <el-option label="已付款" :value="3"></el-option>
            <el-option label="已发货" :value="4"></el-option>
            <el-option label="已完成" :value="5"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="statusDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpdateStatus">保存修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { order_list, order_status_modify } from '../api/api'
import OrderDetail from '../components/OrderDetail/OrderDetail.vue'
export default {
  components: { OrderDetail },
  data() {
    return {
      tableData: [],
      ids: [],
      currentPage: 1,
      pageSize: 20,
      totalcount: 0,
      order_sn: "",
      filter_email:"",
      filter_user_id:0,
      detailVisible: false,
      selected_order: null,

      // 修改状态弹窗
      statusDialogVisible: false,
      editOrder: {
        order_id: null,
        order_sn: '',
        order_status: null
      }
    };
  },

  methods: {
    handleSearch() {
      this.currentPage = 1
      this.getOrderList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOrderList();
    },

    // 打开修改状态弹窗
    openStatusDialog(row) {
      this.editOrder.order_id = row.order_id
      this.editOrder.order_sn = row.order_sn
      this.editOrder.order_status = row.order_status
      this.statusDialogVisible = true
    },

    // 提交修改订单状态
    async submitUpdateStatus() {
      try {
        const params = {
          order_id: this.editOrder.order_id,
          order_status: this.editOrder.order_status
        }
        const res = await order_status_modify(params)

        
        // if (res.code === 0) {
          this.$message.success("状态修改成功")
          this.statusDialogVisible = false
          this.getOrderList()
        // } else {
        //   this.$message.error(res.msg || "修改失败")
        // }
      } catch (e) {
        console.error(e)
        this.$message.error("接口请求异常")
      }
    },

    // 打开详情弹窗
    openDetail(order) {
      this.selected_order = order
      this.detailVisible = true
    },
    resetDetail() {
      this.selected_order = null
    },

    // 单行删除
    handleDelete(row) {
      this.$confirm("确认删除该订单？删除后不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // TODO: 替换真实删除接口
        /*
        this.$axios.delete(`/api/admin/order/${row.order_id}`).then(res=>{
          if(res.code===0){
            this.$message.success("删除成功")
            this.getOrderList()
          }
        })
        */
      }).catch(() => { })
    },

    // 批量删除
    handleDeleteBatch() {
      const ids = this.ids.join(",");
      if (!ids) {
        this.$message.warning("您还未选择任何订单");
        return;
      }
      this.$confirm("确认批量删除选中订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // TODO: 批量删除接口
      }).catch(() => { })
    },

    handleSelectionChange(val) {
      this.ids = val.map(item => item.order_id);
    },

    // 请求订单列表
    async getOrderList() {
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
          order_sn: this.order_sn,
          filter_email:this.filter_email,
          filter_user_id:this.filter_user_id
        }
        const res = await order_list(params)
        this.totalcount = res.total;
        this.tableData = res.list;
      } catch (error) {
        console.error("getOrderList-error:", error)
        this.$message.error("订单列表加载失败")
      }
    },

    // 状态tag配色，对齐后端常量 0~5
    getTagType(status) {
      const map = {
        0: 'warning',  // 0 已创建(待支付)
        1: 'info',     // 1 已回复
        2: 'primary',  // 2 已确认
        3: 'success',  // 3 已付款
        4: '',         // 4 已发货
        5: 'success'   // 5 已完成
      }
      return map[status] || ''
    }
  },
  mounted() {
    this.getOrderList();
  }
};
</script>

<style scoped>
.tool-tips {
  margin: 20px 0;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>